import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "@appcues/component-library";
import AudienceBaseClause from "components/Common/Clauses/AudienceBase";
import UserHistoryDateRange from "components/Common/UserHistoryDateRange";
import { getCompletionEventLabel } from "utils/conditions";
import "components/Common/Clauses/Content/style.scss";
import ToggleableSelect from "components/Common/Clauses/ToggleableSelect";
import SelectStepGroup from "components/Common/SelectStepGroup";
import { selectStepGroup } from "reducers/account/flows";

class ContentClause extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAdditionalInfo: undefined
    };
  }

  render() {
    const { readOnly, step, clause, updateClause } = this.props;

    const verb = getCompletionEventLabel(step);

    const timesOperators = [
      {
        value: false,
        label: `has been ${verb}`
      },
      {
        value: true,
        label: `has not been ${verb}`
      }
    ];

    const showAdditionalInfo =
      this.state.showAdditionalInfo === undefined
        ? parseInt(clause.times, 10) > 1 || parseInt(clause.value, 10) > 0
        : this.state.showAdditionalInfo;

    const value = "negative" in clause ? clause.negative : false;
    const readOnlyDisplay = value ? `has not been ${verb}` : `has been ${verb}`;

    return (
      <div className="content-targeting">
        <AudienceBaseClause {...this.props}>
          <div className="sub-clause">
            <SelectStepGroup
              value={clause.content}
              onChange={content => {
                updateClause(clause.id, { content });
              }}
            />
            <ToggleableSelect
              className="select-content-operator"
              clearable={false}
              readOnlyContent={readOnlyDisplay}
              value={value}
              options={timesOperators}
              autosize={false}
              onChange={opt => {
                updateClause(clause.id, { negative: opt.value });
              }}
              operator
              readOnly={readOnly}
            />
            <Button
              className="timeframe-options"
              onClick={() => {
                this.setState({
                  showAdditionalInfo: !showAdditionalInfo
                });
              }}
            >
              {showAdditionalInfo ? `Hide Options` : `Show Options`}
            </Button>
          </div>
        </AudienceBaseClause>
        {(() => {
          if (showAdditionalInfo) {
            return (
              <UserHistoryDateRange
                clause={clause}
                readOnly={readOnly}
                updateClause={updateClause}
              />
            );
          }
          return null;
        })()}
      </div>
    );
  }
}

function mapStateToProps(state, { clause: { content: stepId } }) {
  return {
    step: selectStepGroup(state, { stepId })
  };
}

export default connect(mapStateToProps)(ContentClause);
